<mat-card
  class="item-card"
  [ngClass]="{
    'with-value': showQuantity || uiRoleManagerService.canI(eRoleActions.VIEW_VALUE),
    selected: isSelected,
    'border-2 border-danger': item.isInLoanOut,
    'neighbors-selected': storeService.store.neighborsViewItem?.id === item.id,
  }"
>
  <mat-card-header class="pt-2 px-2">
    <mat-card-title [title]="item.description" class="item-title">{{ item.description }} </mat-card-title>

    <mat-card-subtitle class="item-icons">
      <div class="d-flex align-items-center">
        <span class="inventory-label mr-1">{{ item.inventory }}</span>
        <div class="flex-grow-1"></div>

        @if (item.is_sold && item.sale?.date) {
          <mat-icon
            class="mr-1 cursor-pointer"
            [routerLink]="['/scarichi/lista', item?.sale?.id]"
            color="primary"
            matTooltipClass="multi-line-tooltip"
            [matTooltip]="getSaleTooltipText()"
            >event</mat-icon
          >
        }
        @if (item.isInLoanOut) {
          <mat-icon
            class="mr-1 cursor-pointer"
            [routerLink]="['/prestiti', item?.loanOut?.loan?.id]"
            color="warn"
            [matTooltip]="'COMMON.LABEL.BORROWED' | translate"
            >work</mat-icon
          >
        }
        @if (item.suit?.id) {
          <mat-icon color="primary" [matTooltip]="'COMMON.LABEL.SUIT' | translate">category</mat-icon>
        }
      </div>

      <div class="d-flex justify-content-between border-top pt-1 mt-1 value">
        <div>
          @if (showQuantity) {
            N&deg;
            @if (item.quantity !== undefined) {
              <strong>{{ item.quantity }}</strong>
            }
            @if (item.quantity === undefined) {
              <strong>n.d</strong>
            }
          }
        </div>
        <div *bitfUiRoleManager="{ action: eRoleActions.VIEW_VALUE }">
          <strong>{{ getValueText() }}</strong>
        </div>
      </div>
    </mat-card-subtitle>

    @if (isSelected) {
      <mat-icon class="selected-icon position-absolute"> check_circle </mat-icon>
    }
  </mat-card-header>

  <mat-card-content class="d-flex position-relative" (click)="onSelect()" matTooltipPosition="below">
    <mpa-item-images class="item-image-container" [item]="item" [showImagesCounter]="false"></mpa-item-images>
  </mat-card-content>

  <mat-card-actions class="d-flex justify-content-between align-items-center button-density-2">
    <button (click)="onItemDetail()" mat-icon-button>
      <mat-icon>visibility</mat-icon>
    </button>

    <button (click)="onItemDetail(true)" mat-icon-button>
      <mat-icon>zoom_out_map</mat-icon>
    </button>

    <button
      mat-icon-button
      matTooltipClass="multi-line-tooltip"
      [matTooltip]="getTooltipText()"
      matTooltipPosition="above"
    >
      <mat-icon color="primary">info</mat-icon>
    </button>

    @if (!isReadOnly) {
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
    }

    <mat-menu #menu="matMenu">
      <button
        mat-menu-item
        *bitfUiRoleManager="{ action: eRoleActions.DELETE_ITEM }"
        (click)="onDelete('deleteItem')"
        class="text-danger"
      >
        <span>{{ 'COMMON.LABEL.DELETE' | translate }}</span>
      </button>

      @if (folder && uiRoleManagerService.canI(eRoleActions.REMOVE_FROM_FOLDER)) {
        <button mat-menu-item (click)="onDelete('deleteFromFolder')" class="text-danger">
          <span>{{ 'FOLDER.REMOVE_FROM_FOLDER' | translate }}</span>
        </button>
      }
    </mat-menu>
  </mat-card-actions>
</mat-card>
